/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowConfiguratorSummaryQueryResponse, GetShowConfiguratorSummaryPathParams, GetShowConfiguratorSummaryQueryParams, GetShowConfiguratorSummary401, GetShowConfiguratorSummary403, GetShowConfiguratorSummary404 } from "../../models/GetShowConfiguratorSummary";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowConfiguratorSummaryUrl({ code }: { code: GetShowConfiguratorSummaryPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/configurator/summary` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/configurator/summary}
 */
export async function getShowConfiguratorSummary({ code, params }: { code: GetShowConfiguratorSummaryPathParams["code"]; params: GetShowConfiguratorSummaryQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowConfiguratorSummaryQueryResponse, ResponseErrorConfig<GetShowConfiguratorSummary401 | GetShowConfiguratorSummary403 | GetShowConfiguratorSummary404>, unknown>({ method : "GET", url : getGetShowConfiguratorSummaryUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}